/* @flow */
import * as React from 'react';

// Styles
import styles from './UpcomingBraindateCardFooter.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

// Utils
import { isGroupTopic } from '@braindate/domain/lib/topic/util';
import { getBraindateTopic } from 'src/shared/domain/braindate/util/braindateUtil';
import { getConversationParticipants } from '@braindate/domain/lib/conversation/util';
import {
  getBraindateConversation,
  getBraindateSpotsLeft,
} from '@braindate/domain/lib/braindate/util';

// Components
import GroupAvatarQueue from 'src/shared/ui/component/image/GroupAvatarQueue';
import BraindateCardAuthor from '../BraindateCardAuthor';
import UpcomingBraindateCardCheckIn from './UpcomingBraindateCardCheckIn';

// Types
import type { Braindate } from '@braindate/domain/lib/braindate/type';

const useStyles = createUseThemeStyles(styles);

type Props = {
  braindate: Braindate,
  showCheckin: boolean,
};

const UpcomingBraindateCardFooter = ({ braindate, showCheckin }: Props) => {
  /*
  |------------------------------------------------------------------------------
  | Hooks
  |------------------------------------------------------------------------------
  */
  const classes = useStyles();

  const topic = getBraindateTopic(braindate);
  const isGroupBraindate = isGroupTopic(topic);

  /*
  |------------------------------------------------------------------------------
  | Elements
  |------------------------------------------------------------------------------
  */

  return (
    <div className={classes.root}>
      <BraindateCardAuthor braindate={braindate} />

      <div className={classes.right}>
        {isGroupBraindate && (
          <GroupAvatarQueue
            // $FlowIssue Will always be defined if it's a group braindate
            spots={getBraindateSpotsLeft(braindate)}
            participants={getConversationParticipants(
              getBraindateConversation(braindate),
            )}
            layoutClass={classes.avatarQueue}
          />
        )}

        <UpcomingBraindateCardCheckIn
          braindate={braindate}
          showCheckin={showCheckin}
        />
      </div>
    </div>
  );
};

export default React.memo<Props>(UpcomingBraindateCardFooter);
